import { useEffect, useState } from "react";
import LoadingOverlay from "../../components/loadingOverlay";
import ActivityCard from "./activityCard";
import { API_BASE } from "../../config/apiConfig";

export default function CoachActivitiesTab() {
  const token = sessionStorage.getItem("access_token");

  const [loading, setLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);

  const [searching, setSearching] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [status, setStatus] = useState("All");
  const [type, setType] = useState("All");
  const [ranking, setRanking] = useState("All");
  const [sort, setSort] = useState("latest");

  useEffect(() => {
    if (!searching) loadPage(1);
  }, [status, type, ranking, sort]);

  useEffect(() => {
    if (!searching) loadPage(page);
  }, [page]);

  async function loadPage(pg) {
    setLoading(true);

    try {
      const url = new URL(`${API_BASE}/api/player-coach-activities`);
      url.searchParams.append("page", pg);
      url.searchParams.append("status", status);
      url.searchParams.append("type", type);
      url.searchParams.append("rankingType", ranking);
      url.searchParams.append("sort", sort);

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (data.success) {
        setActivities(data.activities);
        setTotal(Math.ceil(data.total / 8));
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <LoadingOverlay show={loading} />

      {/* Filters */}
      {!searching && (
        <div className="flex flex-wrap gap-3 mb-4">
          <select value={status} onChange={(e) => setStatus(e.target.value)} className="border p-2 rounded">
            <option value="All">All Status</option>
            <option value="active">Active</option>
            <option value="upcoming">Upcoming</option>
            <option value="full">Full</option>
          </select>

          <select value={type} onChange={(e) => setType(e.target.value)} className="border p-2 rounded">
            <option value="All">All Types</option>
            <option value="event">Event</option>
            <option value="tournament">Tournament</option>
            <option value="camp">Camp</option>
            <option value="talk">Talk</option>
            <option value="seminar">Seminar</option>
            <option value="workshop">Workshop</option>
            <option value="sparring">Sparring</option>
            <option value="fitness">Fitness</option>
            <option value="friendlyMatch">Friendly Match</option>
          </select>

          {type === "tournament" && (
            <select value={ranking} onChange={(e) => setRanking(e.target.value)} className="border p-2 rounded">
              <option value="All">All Rankings</option>
              <option value="National">National</option>
              <option value="AJSS">AJSS</option>
            </select>
          )}

          <button
            onClick={() => setSort(sort === "latest" ? "oldest" : "latest")}
            className="px-3 py-2 bg-gray-200 rounded"
          >
            {sort === "latest" ? "Latest ↓" : "Oldest ↑"}
          </button>
        </div>
      )}

      {/* List */}
      <div className="grid gap-4">
        {activities.map((a, idx) => (
          <ActivityCard key={a.id} activity={a} idx={idx}/>
        ))}
      </div>

      {/* Pagination */}
      {!searching && total > 1 && (
        <div className="flex justify-center gap-4 mt-4">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            Prev
          </button>

          <span>
            Page {page} / {total}
          </span>

          <button disabled={page === total} onClick={() => setPage(page + 1)}>
            Next
          </button>
        </div>
      )}
    </>
  );
}
